import format from 'date-fns/format';

export function formatDateForInput(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}
